import React, { Component } from 'react';
import moment from 'moment'
import firebase from "firebase/app";
import functions from "firebase/functions";
import { connect } from 'react-redux'
import styled from "styled-components";
import * as MDICONS from '@material-ui/icons';
import NotificationControl from './NotificationControl';
import { get } from 'lodash'
import { readThisProjectNotification } from '../../store/actions/notificationActions';
// import { readThisNotification } from '../../store/actions/notificationActions';

const NotificationButton = styled.div`
    .btn {
        color: ${(props) => props.themeColors.themeColor};
        border-color: ${(props) => props.themeColors.invisibleColor};
        background-color: ${(props) => props.themeColors.invisibleColor};
        margin: 2px;

        &:hover {
            color: ${(props) => props.themeColors.themeColor};
            background-color: ${(props) => props.themeColors.invisibleColor};
        }

        &:active {
            color: ${(props) => props.themeColors.themeActiveColor};
            background-color: ${(props) => props.themeColors.invisibleColor};
        }
    }
`;

class ProjectNotificationDrawer extends Component {
    readThisNotification = () => {
        const { project, projectNotificationsMeta } = this.props;
        this.props.readThisProjectNotification(project.proid, projectNotificationsMeta);
    }

    render() {
        const { projectDataNotification, projectNotificationsMeta, themeColors, userData,commons } = this.props;
        const { totalNotifications, totalNotificationsRead } = projectNotificationsMeta ? projectNotificationsMeta : { "totalNotifications": 0, "totalNotificationsRead": 0 };
        var totalUnreadNotifications = (totalNotifications ? totalNotifications : 0) - (totalNotificationsRead ? totalNotificationsRead : 0);

        // if (totalUnreadNotifications > 0) {
        //     const audio = new Audio("https://firebasestorage.googleapis.com/v0/b/snaggingapp-72f9c.appspot.com/o/SI-templates%2Fstatic%2Ftones%2Fjuntos-607.mp3?alt=media&token=cedff358-d1ce-48aa-8e8f-049e7e26bb1f");
        //     audio.load();
        //     audio.autoplay = true;
        // }

        var numberToDisplay = Number.isNaN(totalUnreadNotifications) || totalUnreadNotifications <= 0 ? <React.Fragment /> : <span style={{ marginLeft: "10px" }}>{totalUnreadNotifications}</span>
        var iconToDisplay = Number.isNaN(totalUnreadNotifications) || totalUnreadNotifications <= 0 ? <MDICONS.Notifications /> : <MDICONS.NotificationsActive />
        // console.log(projectDataNotification)
        return (
            <div className="section">
                <div>
                    <div className="dropdown dropleft">
                        <NotificationButton themeColors={themeColors} onClick={() => this.readThisNotification()}>
                            <button className="btn btn-flat" type="button" data-toggle="dropdown" key={Math.random()}>
                                {iconToDisplay}
                                {numberToDisplay}
                            </button>

                            {/* https://stackoverflow.com/questions/51543672/how-to-increase-div-size-in-navbar-dropdown-menu-in-bootstrap-4 */}
                            <ul className="dropdown-menu" style={{borderRadius:'10px', width: "25rem", maxHeight: "380px", overflowY: "auto" }}>
                                <div className="align-self-start m-2">
                                    <h5 className="" style={{ font: "bold" }}><b>Project notifications</b></h5>
                                <p className="" style={{color:'gray',fontSize:'12px',fontWeight:'bold'}}>View {commons.project} requests and general alerts.</p>
                                </div>
                                {projectDataNotification && projectDataNotification.length >0  ? projectDataNotification.map(item => {
                                    return (
                                        <li className="card p-2 m-2" style={{borderRadius:'10px'}} key={item.timestamp}>
                                            <NotificationControl notificationItem={item} />
                                            <div className="d-flex">
                                                <div className="p-2 flex-fill"><small>{moment(item.timestamp.toDate()).fromNow()}</small></div>
                                            </div>
                                        </li>
                                    )

                                }):<div className="m-5" style={{textAlign:'center'}}>
                                    <MDICONS.Done style={{scale:'1.5'}}/>
                                    <p style={{fontSize:'18px'}}><b>Nothing pending</b></p>
                                    <p style={{fontSize:'14px'}}>You will receive {commons.project} notifications here with a call to action</p>
                                    </div>}
                            </ul>
                        </NotificationButton>
                    </div>
                </div>
            </div >
        );
    }
}

const mapStateToProps = (state) => {

    return {
        themeColors: state.theme,
        dashboardSidebarSize: state.appControl.dashboardSidebarSize,
        companyData: state.firestore.data.Company,
        projectDataNotification: state.firestore.ordered.ProjectNotifications,
        userData: state.firebase.profile,
        commons:state.commons,
        project: state.project,
        snagDetail: get(state.firestore.data, `Snag.${state.project.proid}`),
        projectNotificationsMeta: get(state.firebase.data, `ProjectsMeta.${state.project.proid}.Notifications`),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        readThisProjectNotification: (proid, meta) => dispatch(readThisProjectNotification(proid, meta))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(ProjectNotificationDrawer);